import { render, staticRenderFns } from "./popularLiterature.vue?vue&type=template&id=c69f6548&scoped=true&"
import script from "./popularLiterature.vue?vue&type=script&lang=js&"
export * from "./popularLiterature.vue?vue&type=script&lang=js&"
import style0 from "./popularLiterature.vue?vue&type=style&index=0&id=c69f6548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69f6548",
  null
  
)

export default component.exports